import { render, staticRenderFns } from "./bar-chart.vue?vue&type=template&id=4d0bf594&scoped=true&"
import script from "./bar-chart.vue?vue&type=script&lang=ts&"
export * from "./bar-chart.vue?vue&type=script&lang=ts&"
import style0 from "./bar-chart.vue?vue&type=style&index=0&id=4d0bf594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0bf594",
  null
  
)

export default component.exports